// API adapters and core host-binding admission share one authority implementation.
export { requireConnectOwnerAuthority } from "@opengeni/core";
